import { createBrowserRouter } from 'react-router-dom'

import AddressSearchPage from '@/pages/AddressSearchPage/page'
import ServiceAreaPage from '@/pages/ServiceAreaPage/page'

import { ROUTES } from './routes'

const router = createBrowserRouter([
  {
    path: ROUTES.ROOT,
    element: <ServiceAreaPage />,
  },
  {
    path: ROUTES.SEARCH,
    element: <AddressSearchPage />,
  },
])

export default router
